export const visit = (vm, at) => {
vm(require("foundations-components/lang/et.lyaml"));
at({ "et": { "placeholder": "kohat\xE4ide" } });
};